import isPlainObject from 'lodash/isPlainObject';
import transform from 'lodash/transform';
import { prepareConfig, nodeNamesToPath, getReplaceValue } from './util.common.js';

/* eslint-disable no-param-reassign */
// eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle
const _transformData = (data, { filterConfig, replaceConfig }, parentPath = '') => transform(data, (result, value, key) => {
    const currentPath = nodeNamesToPath([parentPath, key]);
    // Recurse into arrays and objects.
    if (Array.isArray(value) || isPlainObject(value)) {
        value = _transformData(value, {
            filterConfig,
            replaceConfig,
        }, currentPath);
    }
    if (filterConfig[currentPath]) {
        return;
    }
    const newValue = getReplaceValue(value, replaceConfig[currentPath]);
    if (Array.isArray(result)) {
        result.push(newValue);
        return;
    }
    result[key] = newValue;
});
/**
 *  Преобразование полей объекта на основе конфига
 *
 * @param data {Object|Array} данные для преобразования
 * @param config {TransformConfig} конфиг с функциями преобразования и путей для фильтра
 */
const transformData = (data, config) => _transformData(data, prepareConfig(config));

export { transformData };
